import styled from 'styled-components';
import { Flex } from 'antd';

export const ContentContainer = styled(Flex)`
  flex-grow: 1;

  .building-icon {
    font-size: 70px;
    color: var(--clr-icon-color);
  }
`;
